import { MATERIAL, MODEL_ID, PROVIDER } from 'Pods/ThreeDStudio/Store/constants'

const MATERIAL_TO_MATERIAL_MODE = {
  [MATERIAL.PBR]: 'PBR',
  [MATERIAL.BASIC]: 'shaded',
  [MATERIAL.GEOMETRY_ONLY]: 'shaded',
}

/**
 * Inverse of parseHyper3dImageTo3dGen2Data. Builds an openedModel-shaped
 * payload from the current modelSettings so the just-submitted run can be
 * reopened without an extra API round-trip.
 *
 * @param {Object} state - ThreeDStudio store state (getState())
 * @param {string|number} id - Run id from the generation API response
 * @returns {Object} - openedModel payload accepted by parseHyper3dImageTo3dGen2Data
 */
export const buildHyper3dImageTo3dGen2FromState = (state, id) => {
  const {
    material,
    targetPolycount,
    polygonType,
    inputImage,
    inputImageUrl,
    isPrivate,
    selectedUseCase,
  } = state.modelSettings || {}
  const materialMode = material != null ? MATERIAL_TO_MATERIAL_MODE[material] : undefined

  const inputAssets = inputImage != null
    ? [{
        assetType: 'image',
        source: 'user_upload',
        assetId: inputImage,
        fileUrl: inputImageUrl,
      }]
    : undefined

  return {
    id,
    providerKey: PROVIDER.HYPER3D,
    providerModelId: MODEL_ID.HYPER3D_IMAGE_TO_3D_GEN2,
    private: isPrivate,
    useCase: selectedUseCase,
    inputAssets,
    providerRunAttributes: {
      ...(targetPolycount != null && { polycount: targetPolycount }),
      ...(polygonType != null && { topology: polygonType }),
      ...(materialMode != null && { materialMode }),
    },
  }
}
